export default "__VITE_ASSET__Bah_jl3X__"